import {
	creditRanges
} from '../config/settings.js';

import { getSelectedPriceValue } from '../helpers/pricing.js';

import { 
	WALLET_CONFIG_KEY,
	LS_PENCIL_EVENT_KEY,
	MMD_WIDGET_SELECTOR
} from '../global-constants.js';
import { getDealerDRLeaseEnabled } from '../helpers/index.js';

const hasAccelerate = window.CADigitalRetailObject;

const logEventDataToLocalStorage = (data) => {
	localStorage.setItem(LS_PENCIL_EVENT_KEY, JSON.stringify(data));
}

// For Accelerate integration
export const updateShopper = (walletConfig, vehicle, oldWalletConfig, refreshAccelerate) => {
	// Used by ws-tracking
	if (walletConfig) {
		let walletObj = { ...walletConfig };
		// if walletConfig doesn't have walletId,
		// concat it with previous wallet in local storage (if it exists)
		// to include walletId, interaction fields, etc.
		if (!walletObj.walletId) {
			const prevWalletObj = JSON.parse(localStorage.getItem(WALLET_CONFIG_KEY)) || {};
			const dealTypeValue = walletObj?.dealType || prevWalletObj.dealType;
			const paymentOptionValue =  walletObj?.paymentOption || prevWalletObj.paymentOption;
			
			// Preserve interaction flags - ensure true values are not overwritten
			const preservedInteractions = {
				...prevWalletObj.interactions,
				...walletObj.interactions,
				hasUpdatedWallet: prevWalletObj.interactions?.hasUpdatedWallet || walletObj.interactions?.hasUpdatedWallet || false,
				hasOpenedWallet: prevWalletObj.interactions?.hasOpenedWallet || walletObj.interactions?.hasOpenedWallet || false
			};
			
			walletObj = { 
				...prevWalletObj,
				...walletObj,
				dealType: dealTypeValue,
				paymentOption: paymentOptionValue,
				interactions: preservedInteractions
			};
		}

		localStorage.setItem(WALLET_CONFIG_KEY, JSON.stringify(walletObj));
	}

	if (!(walletConfig && hasAccelerate)) {
		return;
	}

	const creditType = walletConfig?.creditType || oldWalletConfig?.creditType;
	const leaseTerm = walletConfig?.leaseTerm || oldWalletConfig?.leaseTerm;
	const loanTerm = walletConfig?.loanTerm || oldWalletConfig?.loanTerm;
	const downPayment = walletConfig?.downPayment || oldWalletConfig?.downPayment;
	const downPaymentPercent = walletConfig?.downPaymentPercent || oldWalletConfig?.downPaymentPercent;
	const leaseMileageRange = walletConfig?.leaseMileageRange || oldWalletConfig?.leaseMileageRange;
	const tradeIn = walletConfig?.tradeIn || oldWalletConfig?.tradeIn;
	const walletId = walletConfig?.walletId || oldWalletConfig?.walletId;

	const isPaymentOptionsEnabled = getDealerDRLeaseEnabled();
	
	let dealType;
	if (isPaymentOptionsEnabled) {
		dealType = walletConfig?.paymentOption;
	} else {
		dealType = walletConfig?.dealType || 'finance';
	}

	// Get the price value for the Dealer's chosen price field
	const priceFieldValue = getSelectedPriceValue(vehicle);

	let shopper = {
		defaultOfferType: dealType,
		walletId,
	};

	if (creditType) {
		const [ creditScoreLow, creditScoreHigh ] = creditRanges[creditType];
		shopper = {
			...shopper,
			creditScoreLow,
			creditScoreHigh
		};
	}

	if (loanTerm) {
		shopper.financeTermMonths = loanTerm;
	}

	if (leaseTerm) {
		shopper.leaseTermMonths = leaseTerm;
	}

	const newDownPayment = (!downPayment && downPaymentPercent && priceFieldValue > 0)
		? Math.round(priceFieldValue * downPaymentPercent)
		: downPayment;

	if (newDownPayment) {
		shopper.downPayment = newDownPayment;
	}

	if (leaseMileageRange) {
		shopper.annualMiles = leaseMileageRange;
	}

	if (!tradeIn.amountOwed) {
		tradeIn.amountOwed = 0;
	}

	if (tradeIn.condition) {
		tradeIn.condition = tradeIn.condition.toLowerCase();
	}

	const previousShopper = JSON.stringify(window.CADigitalRetailObject.shopper);
	const newShopper = JSON.stringify(shopper);

	window.CADigitalRetailObject.shopper = shopper;

	let previousTrade;
	let newTrade;

	if (tradeIn) {
		tradeIn.isNetTradeAppliedToFinancing = true;
		tradeIn.source = 'USER';

		previousTrade = JSON.stringify(window.CADigitalRetailObject.trade);
		newTrade = JSON.stringify(tradeIn);

		window.CADigitalRetailObject.trade = tradeIn;
	}

	const shouldRefreshWidget =
		(previousShopper !== newShopper || previousTrade !== newTrade) &&
		typeof window.refreshAccelerateWidget === 'function' &&
		refreshAccelerate;

	if (shouldRefreshWidget) {
		window.refreshAccelerateWidget();

		// track in pixall every time we refresh accelerate with wallet data
		const { uuid, vin, stockNumber, year, make, model, inventoryType } = vehicle;
		window.DDC.pushToPixall({
			type: 'event',
			feature: 'MyWallet',
			eventSource: 'calculator',
			eventType: 'autofill',
			calculatorType: 'payment',
			label: 'MyWallet -> Accelerate Auto Pencil Update',
			vehicleId: uuid,
			vin,
			stockNumber,
			year,
			make,
			model,
			vehicleType: inventoryType
		}, {
			source: 'cms-web'
		});

		// if this is an auto pencil event, we need to track it once AMD updates
		if (walletConfig?.autoPencil) {
			logEventDataToLocalStorage(walletConfig);
		}
	}

	// If we should track this as auto pencil event
	// and accelerate widget has not loaded yet,
	// we can assume the user has not scrolled it into view
	if (
		walletConfig?.autoPencil &&
		hasAccelerate &&
		typeof window.refreshAccelerateWidget !== 'function' &&
		document.querySelector(MMD_WIDGET_SELECTOR)?.textContent === ''
	) {
		logEventDataToLocalStorage(walletConfig);
	}
}
